import React from 'react';
import { Flex } from 'rebass';
import { Input as InnerInput, Label } from '@rebass/forms';
import baseTheme from '../../../themes/baseTheme';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#627CFF',
      dark: '#4f6a92'
    },
    secondary: {
      main: '#f44336'
    },
    text: {
      primary: '#4f6a92',
      secondary: '#4f6a92'
    }
  },
  typography: {
    useNextVariants: true
  }
});

export default props => (
  <Flex {...props} flexWrap="wrap">
    <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
  </Flex>
);
